import { combineReducers } from 'redux';
import listReducer from './reducers/list';
import detailReducer from './reducers/detail';

export default combineReducers({
  list: listReducer,
  detail: detailReducer
});
